import React from "react";
import { System } from "../../../../../context";
import {
  APMISOnlineForm,
  APMISOnlineFormValues,
} from "./forms/ap-mis-online-form";
import {
  CybersourceForm,
  CybersourceFormValues,
} from "./forms/cybersource-form";
import { FinanceForm, FinanceFormValues } from "./forms/finance-form";
import {
  LocalPCAdminExceptionForm,
  LocalPCAdminExceptionFormValues,
} from "./forms/local-pc-admin-exception-form";
import {
  MIGSMerchantManagerOperationPrivilegeForm,
  MIGSMerchantManagerOperationPrivilegeFormValues,
} from "./forms/migs-merchant-manager-operation-privilege-form";
import {
  RemovableMediaExceptionAuthorizationForm,
  RemovableMediaExceptionAuthorizationFormValues,
} from "./forms/removable-media-exception-authorization";
import { RiskNetForm, RiskNetFormValues } from "./forms/risknet-form";
import { SalesforceForm } from "./forms/salesforce/salesforce-form";
import { REGIONS, SalesforceFormValues } from "./forms/salesforce/details";
import {
  SharedDriveForm,
  SharedDriveFormValues,
} from "./forms/shared-drive-form";
import { ThirdPartyForm, ThirdPartyFormValues } from "./forms/third-party-form";
import {
  UPOPAcquirerPortalOperatorPrivilegeForm,
  UPOPAcquirerPortalOperatorPrivilegeFormValues,
} from "./forms/upop-acquirer-portal-operator-privilege-form";
import { WinscpForm, WinscpFormValues } from "./forms/winscp-form";
import { WorkdayForm, WorkdayFormValues } from "./forms/workday-form";
import { GSAPForm, GSAPFormValues } from "./forms/GSAPForm";

// ⭐ ADD THIS
import { KiteworksForm, KiteworksFormValues } from "./forms/KITEWORKSForm";

export type Values =
  | APMISOnlineFormValues
  | CybersourceFormValues
  | FinanceFormValues
  | LocalPCAdminExceptionFormValues
  | MIGSMerchantManagerOperationPrivilegeFormValues
  | RemovableMediaExceptionAuthorizationFormValues
  | RiskNetFormValues
  | SalesforceFormValues
  | SharedDriveFormValues
  | ThirdPartyFormValues
  | UPOPAcquirerPortalOperatorPrivilegeFormValues
  | WinscpFormValues
  | WorkdayFormValues
  | GSAPFormValues
  // ⭐ ADD THIS TO UNION
  | KiteworksFormValues;

type Props = {
  application: System["application"];
  onCancel: () => void;
  onSubmit: (values: Values) => void;
  open: boolean;
  values: any;
  readonly?: boolean;
  isResubmitForm?: boolean;
  financeFormSecuritiesForResubmit?: any;
  isViewSubmittedRequest?: boolean;
};

export const AdditionalFormModal: React.FC<Props> = ({
  application,
  isResubmitForm,
  financeFormSecuritiesForResubmit,
  isViewSubmittedRequest,
  ...props
}) => {
  switch (application.additionalForm) {
    case "AP_MIS_Online":
      return <APMISOnlineForm {...props} />;
    case "CyberSource_Form":
      return <CybersourceForm {...props} />;
    case "FormFinance":
      return (
        <FinanceForm
          application={application.id}
          title={application.name}
          isResubmitForm={isResubmitForm}
          financeFormSecuritiesForResubmit={financeFormSecuritiesForResubmit}
          {...props}
        />
      );
    case "GSAP_Form":
      return <GSAPForm {...props} />;

    // ⭐ NEW KITEWORKS FORM
    case "Kiteworks_Form":
      return <KiteworksForm {...props} />;

    case "FormThirdParty":
      return (
        <ThirdPartyForm
          isViewSubmittedRequest={isViewSubmittedRequest}
          template={application.formTemplate || application.formTemplate2}
          {...props}
        />
      );
    case "FormWinscp":
      return <WinscpForm title={application.name} {...props} />;
    case "LocalPCAdminException_Form":
      return <LocalPCAdminExceptionForm {...props} />;
    case "MIGSMerchantManagerOperationPrivilege_Form":
      return <MIGSMerchantManagerOperationPrivilegeForm {...props} />;
    case "Removable_Media_Exception_Authorization_Form":
      return <RemovableMediaExceptionAuthorizationForm {...props} />;
    case "risknet_form":
      return <RiskNetForm {...props} />;
    case "SalesforceAP_Form":
      return <SalesforceForm region={REGIONS.AP} {...props} />;
    case "SalesforceMNC_Form":
      return <SalesforceForm region={REGIONS.MNC} {...props} />;
    case "SalesforceUK_Form":
      return <SalesforceForm region={REGIONS.UK} {...props} />;
    case "SalesforceCSP_Form":
      return <SalesforceForm region={REGIONS.CSP} {...props} />;
    case "SalesforceCSPLATAM_Form":
      return <SalesforceForm region={REGIONS.CSP_LATAM} {...props} />;
    case "SalesforceCanada_Form":
      return <SalesforceForm region={REGIONS.CANADA} {...props} />;
    case "SalesforceMarketing_Form":
      return <SalesforceForm region={REGIONS.MARKETING} {...props} />;
    case "SalesforceMexico_Form":
      return (
        <SalesforceForm region={REGIONS.MEXICO} language="ESP" {...props} />
      );
    case "SalesforceUKEnt_Form":
      return <SalesforceForm region={REGIONS.UK_ENTERPRISE} {...props} />;
    case "shareddrive_form":
      return <SharedDriveForm {...props} />;
    case "UPOP_Acquirer_Portal_Operator_Privilege_Form":
      return <UPOPAcquirerPortalOperatorPrivilegeForm {...props} />;
    case "Workday":
      return <WorkdayForm {...props} />;
    default:
      return null;
  }
};
